// test572
(572 && 0);
